// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiStepTherapy {
    static getAttributeTypeMap() {
        return PharmacyBiStepTherapy.attributeTypeMap;
    }
}
PharmacyBiStepTherapy.discriminator = undefined;
PharmacyBiStepTherapy.additionalProperties = false;
PharmacyBiStepTherapy.attributeTypeMap = [
    {
        "name": "required",
        "baseName": "required",
        "type": "string"
    },
    {
        "name": "treatment",
        "baseName": "treatment",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiStepTherapy.js.map